// React
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux"
import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter} from 'react-router-dom';

// Components
import App from './App';

// Style
import './assets/css/bootstrap.min.css';
import './assets/css/slick.css';
import './assets/css/animate.css';
import './assets/css/custom.css';
import './assets/css/responsive.css';
import './assets/css/developer.css';
import './assets/css/loader.css';
import store from "./store";

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js